module.exports = "/images/logo-healix.svg?15cce6eb0f2ecf390d2567030c5f75f3";